import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import { Navigate, RouteObject } from 'react-router-dom';
import React from 'react';
import { RATING_PERMISSIONS } from './permissions/Rating';

const RatingPage = React.lazy(() => import('./containers/RatingPage'));

export const ratingRoutes: RouteObject = {
  path: 'rating',
  element: (
    <PermissionsProtectedRoute
      pageId={RATING_PERMISSIONS.pageId}
      currentPath="/rating"
    />
  ),
  children: [
    {
      path: '',
      element: (
        <React.Suspense fallback={undefined}>
          <RatingPage />
        </React.Suspense>
      ),
    },
    { path: '*', element: <Navigate to="/404" /> },
  ],
};
